import { render, staticRenderFns } from "./AdminInputRow.vue?vue&type=template&id=90cdc86c&scoped=true&"
import script from "./AdminInputRow.vue?vue&type=script&lang=js&"
export * from "./AdminInputRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cdc86c",
  null
  
)

export default component.exports